module.exports = __webpack_public_path__ + "img/bank.d71883f0.svg";